import React from 'react';
import PropTypes from 'prop-types';
import MathquillUIElement from 'mathquill-ui';
import QTIAssessmentItem from '../question/QTIAssessmentItem';
import questionHelperServices from '../../services/questionView/QuestionHelperServices';
import sessionReader from '../../store/readHelpers/SessionReader';
import requirementsParser from '../../loading/resources/requirementsParser';
import objectTypes from '../../constants/ObjectTypes';
import a11yIIBScreenReaderService, { A11yForIIBScreenReaderIteration } from '../../services/a11yIIBScreenReaderService';

function reportReady() {}

class PreRenderView extends React.Component {
    static propTypes = {
        question: PropTypes.object.isRequired,
    };

    fakeCallBack() {}

    getQTIAssessmentItem(question) {
        return (
            <QTIAssessmentItem
                callback={this.fakeCallBack}
                choiceSequences={{}}
                context={sessionReader.getContext()}
                isPreRender
                // If CKEditor is pre-rendered in readonly mode, not all code needed is initialized and loaded
                isReadOnly={!requirementsParser.isCkEditorRequiredForQuestion(question)}
                key={`preload_${question.contentRevisionId}`}
                reportReady={reportReady}
                question={question}
                services={questionHelperServices.getServices()}
                userResponses={{}}
                settingValues={{}}
                viewMedia="screen"
            />
        );
    }

    getMathQuillElement(question) {
        // Pre-render a static mathquill element to trigger loading of the Symbola webfont
        if ([
            objectTypes.COMPOSITE,
            objectTypes.EXTENDED_TEXT,
            objectTypes.EXTENDED_TEXT_MATH,
            objectTypes.MATH_ENTRY].includes(question.objectType)) {
            const isA11yIIBScreenReaderSupportedV3 = a11yIIBScreenReaderService
                .isA11yIterationForIIBScreenReaderSupported(A11yForIIBScreenReaderIteration.v3);
            return (
                <MathquillUIElement
                    isStaticMathElement
                    mathquillText="x"
                    isA11yIIBScreenReaderEnabled={isA11yIIBScreenReaderSupportedV3}
                />
            );
        }
        return null;
    }

    render() {
        const { question } = this.props;
        return (
            <React.Fragment>
                {this.getQTIAssessmentItem(question)}
                {this.getMathQuillElement(question)}
            </React.Fragment>
        );
    }
}

export default PreRenderView;
